export const HOME_NEWS_CATEGORIES = [
  'सबसे नई खबरें',
  'राजनीति',
  'शिक्षा',
  'धर्म',
  'मनोरंजन',
  'स्वास्थ्य',
  'आपके लिए',
  'और भी कहानियाँ'
];
